export enum FilterControl {
  SELECTOR = 'SELECTOR',
  DATE = 'DATE',
  INPUT_TEXT = 'INPUT_TEXT',
  INPUT_NUMBER = 'INPUT_NUMBER',
  CHIP_RADIO = 'CHIP_RADIO',
  SEARCH = 'SEARCH'
}

export interface FilterConfig {
  id: string;

  label: string;
  placeholder?: string;
  control: FilterControl;

  // Value that we can use to search on the
  // properties of the therapy jobs
  // e.g for physician, we want to use the ID to search
  bindValue?: string;
  show: boolean;
  multiple?: boolean;

  // show even if is not in the user configuration
  required?: boolean;

  // if we show it in quick filter we do not show it in the sidebar
  showAsQuickFilter?: boolean;
}

export const filtersConfig: Array<FilterConfig> = [
  {
    id: 'prepared',
    label: 'FiltersPreparedLabel',
    control: FilterControl.CHIP_RADIO,
    show: true,
    bindValue: 'value'
  },
  {
    id: 'plannedTime',
    label: 'FiltersPlannedTimeLabel',
    control: FilterControl.DATE,
    placeholder: 'FiltersPlannedTimePlaceholder',
    show: true
  },
  {
    id: 'search',
    label: null,
    control: FilterControl.SEARCH,
    placeholder: 'SearchBar',
    show: true,
    required: true,
    showAsQuickFilter: true
  },
  {
    id: 'patient',
    label: 'FiltersPatientLabel',
    control: FilterControl.SELECTOR,
    placeholder: 'FiltersPatientPlaceholder',
    bindValue: 'id',
    show: true,
    multiple: true
  },
  {
    id: 'room',
    label: 'FiltersRoomLabel',
    control: FilterControl.SELECTOR,
    placeholder: 'FiltersRoomPlaceholder',
    bindValue: 'id',
    show: true,
    multiple: true
  },
  {
    id: 'medicine',
    label: 'FiltersMedicineLabel',
    control: FilterControl.SELECTOR,
    placeholder: 'FiltersMedicinePlaceholder',
    bindValue: 'display',
    show: true,
    multiple: true
  },
  {
    id: 'physician',
    label: 'FiltersPhysicianLabel',
    control: FilterControl.SELECTOR,
    placeholder: 'FiltersPhysicianPlaceholder',
    bindValue: 'id',
    show: false,
    multiple: true
  },
  {
    id: 'carrier',
    label: 'FiltersCarrierLabel',
    control: FilterControl.SELECTOR,
    placeholder: 'FiltersCarrierPlaceholder',
    bindValue: 'description',
    show: false,
    multiple: true
  }
];

export const filterConfigMap: Record<string, FilterConfig> = filtersConfig.reduce(
  (map, obj) => {
    map[obj.id] = obj;
    return map;
  },
  {} as Record<string, FilterConfig>
);
